
import moment from "moment";
import React, { useEffect, useState } from "react";
import AppConfig from './AppConfig.json'
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import * as actions from './actions'
import "./MemberProfile.scss";
import AATagging from "./AATagging";
import * as Helper from "./Helper";


function DataField({ name, value, showNav, nameStyle, valueStyle, iconColor, onClick }) {
    return <div className="data-field" onClick={onClick}>
        <div className="data-name" style={nameStyle}>{name}</div>
        <div className="data-value" style={valueStyle}>{value}</div>
        {showNav && <div className="icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.64645 13.3536C5.45118 13.1583 5.45118 12.8417 5.64645 12.6464L10.2929 8L5.64645 3.35355C5.45118 3.15829 5.45118 2.84171 5.64645 2.64645C5.84171 2.45118 6.15829 2.45118 6.35355 2.64645L11.3536 7.64645C11.4473 7.74022 11.5 7.86739 11.5 8C11.5 8.13261 11.4473 8.25979 11.3536 8.35355L6.35355 13.3536C6.15829 13.5488 5.84171 13.5488 5.64645 13.3536Z" fill={iconColor ? iconColor : 'white'} />
            </svg>
        </div>}
    </div>
}

function MemberProfile({ app }) {
    let { currentUserProfile } = app
    let history = useHistory()

    let profile = currentUserProfile
    useEffect(() => {
        AATagging.trackViewProfile(Helper.getCardNo(currentUserProfile), Helper.isT1X(currentUserProfile))
    }, [])

    const getFullName = () => {
        try {
            if (profile.memberLanguagePref) {
                let lang = profile.memberLanguagePref.toLowerCase()
                return `${profile.firstName[lang]} ${profile.lastName[lang]}`
            }

            return `${profile.firstName["en"]} ${profile.lastName["en"]}`
        }
        catch (err) {
            return `${profile.firstName["th"]} ${profile.lastName["th"]}`
        }
    }

    const maskText = (text, length = 4) => {
        let mask = text.slice(-length)
        return mask.padStart(text.length - length, '*')
    }

    if (!profile) return ""
    return <div className="container">
        <div className="user-profile-wrapper">
            <div className="user-profile-image" style={{ backgroundImage: `url(${profile.imageProfile})` }}></div>
            <div className="user-profile-name">{getFullName()}</div>
            <div className="user-profile-the1-number">The 1 Number: <span>{profile.cards[0].cardNo}</span></div>

        </div>
        <div className="profile-form">
            <h3 className="subtitle">Personal Information</h3>
            <DataField name="Name" value={getFullName()} />
            <DataField name="Date of Birth" value={moment(profile.dateOfBirth, 'YYYY-MM-DD').format('DD MMM YYYY')} />
            <DataField name="Nationality" value={profile.nationalityID} />
            <DataField name="Citizen ID" value={maskText(profile.nationalID)} />

            <h3 className="subtitle">Contact Information</h3>
            <a href="#" onClick={() => {
                AATagging.trackViewProfilePinConfig(Helper.getCardNo(currentUserProfile), Helper.isT1X(currentUserProfile))
                setTimeout(() => {
                    window.location.href = AppConfig.url_app_info_update
                }, 1500)
            }}>
                <div className="hint">การอัพเดตอีเมล หรือเบอร์โทรศัพท์มือถือ จำเป็นต้องระบุ PIN เพื่อยืนยัน หากคุณไม่เคยตั้งค่า PIN มาก่อน สามารถตั้งค่าได้ใน <span className="blue"> The 1 Application</span></div>
            </a>
            <DataField name="Mobile Number" value={profile.mobileNumber} showNav={true} onClick={() => history.push('/member/edit/mobile')} />
            <DataField name="Email" value={profile.email} showNav={true} onClick={() => history.push('/member/edit/email')} />
            <DataField name="Address" value="View details" showNav={true} valueStyle={{ color: '#AAAAAA' }} iconColor="#AAAAAA" onClick={() => history.push('/member/edit/address')} />

            <div className="data-field" onClick={() => history.push('/member/edit/interest')}>
                <div className="data-name bold">Interests</div>
                <div className="data-value"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2844 1.63181C12.8573 1.44744 13.5128 1.58153 13.9654 2.03409C14.418 2.48664 14.552 3.14223 14.3677 3.71511L12.2844 1.63181ZM10.5604 0.978385L3.50572 8.03311L3.50137 8.03742C3.36828 8.17051 3.29567 8.34117 3.28353 8.51526L2.97215 12.3795C2.95401 12.6047 3.03835 12.8261 3.20176 12.9822C3.36516 13.1382 3.5902 13.2123 3.81433 13.1838L7.52045 12.7125C7.66792 12.695 7.81119 12.6339 7.92928 12.529C7.94049 12.519 7.95142 12.5087 7.96206 12.4981L15.0261 5.43409C16.255 4.20519 16.255 2.20232 15.0261 0.973428C13.799 -0.253597 11.8004 -0.255463 10.571 0.967832L10.5653 0.973438L10.5604 0.978385ZM4.5415 11.5792L4.64896 10.2457L5.81995 11.4167L4.5415 11.5792ZM5.09238 8.56777L7.43172 10.9071L13.435 4.90379L11.0957 2.56445L5.09238 8.56777ZM0.799805 14.4497C0.385591 14.4497 0.0498047 14.7855 0.0498047 15.1997C0.0498047 15.6139 0.385591 15.9497 0.799805 15.9497H15.1998C15.614 15.9497 15.9498 15.6139 15.9498 15.1997C15.9498 14.7855 15.614 14.4497 15.1998 14.4497H0.799805Z" fill="white" />
                </svg>
                </div>
            </div>

            <a href="#" onClick={() => {
                AATagging.trackViewProfileGoToApp(Helper.getCardNo(currentUserProfile), Helper.isT1X(currentUserProfile))
                setTimeout(() => {
                    window.location.href = AppConfig.url_app_download
                }, 1500)
            }}>
                <div className="goto-app-wrapper">
                    <img src="/app-logo.png" />
                    <div>
                        <div className="goto-app-text">Go to The 1 App</div>
                        <div className="goto-app-desc">คุณสามารถตั้งค่าบัญชีผู้ใช้ได้อีกช่องทางหนึ่งผ่านทาง The 1 app </div>
                    </div>
                    <div>
                        <div className="goto-app-button">Go</div>
                    </div>
                </div>
            </a>

        </div>
    </div>
}

export default withRouter(connect((state) => state, actions)(MemberProfile))